// src/components/GallerySection.js
import React from "react";
import { Carousel, Container, Row, Col, Card } from "react-bootstrap";

const clients = [
  "CLIENTE0.jpg",
  "CLIENTE1.jpg",
  "CLIENTE2.jpg",
  "CLIENTE3.jpg",
  "CLIENTE4.jpg",
  "CLIENTE5.jpg",
  "CLIENTE6.jpg",
  "CLIENTE7.jpg",
  "CLIENTE8.jpg",
  "CLIENTE9.jpg",
  "CLIENTE10.jpg",
  "CLIENTE12.jpg",
  "CLIENTE13.jpg",
  "CLIENTE14.jpg",
  "CLIENTE15.jpg",
  "CLIENTE16.jpg",
  "CLIENTE17.jpg",
];

const chunkClients = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) {
    chunked.push(array.slice(i, i + size));
  }
  return chunked;
};

const GallerySection = () => {
  const groupedClients = chunkClients(clients, 3);

  return (
    <section className="gallery-section">
      <Container>
        <h2 className="text-center">Clientes Satisfeitos</h2>
        <Carousel
          className="gallery-carousel"
          interval={3000}
          controls={false}
          indicators={false}
        >
          {groupedClients.map((group, index) => (
            <Carousel.Item key={index}>
              <Row className="justify-content-center">
                {group.map((client, clientIndex) => (
                  <Col md={4} sm={6} key={clientIndex} className="mb-4">
                    <Card className="client-card">
                      <Card.Img
                        variant="top"
                        src={`/assets/${client}`}
                        alt={`Cliente ${clientIndex + 1}`}
                        className="client-photo"
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

export default GallerySection;
